import { Message } from "element-ui";
import $crypto from "./crypto";
import store from "@/store";
import utils from '@/utils/utils'

/**
 * 获取缓存数据(没有传值返回所有)
 * @param { userId }
 * @param { docId }
 * @returns { Array }
 */
export const fetchLocalStorageData = (userId, docId) => {
  let _item = localStorage.getItem("webOnlineEditDocInfo");
  let _oldInfo = [];
  if (_item) {
    try {
      _oldInfo = JSON.parse($crypto.decode(_item));
    } catch (error) {
      console.log(error);
      return [];
    }
  } else {
    return [];
  }

  if (!userId || !docId) return _oldInfo;
  // 如果传入了两个 id
  const _targetArray = _oldInfo.filter((e) => {
    return parseInt(e.userId) === parseInt(userId) && parseInt(e.docId) === parseInt(docId);
  });
  return _targetArray;
};

/**
 * 更新缓存的数据
 * @param { userId } 用户 id
 * @param { docId } 文档 id
 * @param { updateData } 更新数据字段
 * @returns 
 */
export const updateLocalStorageData = (userId, docId, updateData) => {
  const _oldInfo = fetchLocalStorageData(userId, docId);
  if (_oldInfo.length) {
    const _newFileData = {
      ..._oldInfo[0],
      ...updateData
    }
    beforeloadNotCheckBycode(_newFileData)
  } else {
    utils.windowToAllSelfPage(`webOnlineEdit/page/error`)
  }
};

// 1. 浏览器打开存储相关数据（重复替换）
export const beforeloadNotCheck2 = (file) => {
  // 当前用户id
  let _itemName = localStorage.getItem("webOnlineEditDocInfo") || "[]";
  let _oldInfo = [];
  try {
    _oldInfo = JSON.parse(_itemName);
  } catch (error) {
    console.log(error);
  }
  let _fileArray;
  if (_oldInfo.length) {
    const index = _oldInfo.findIndex(
      (e) => e.docId === file.docId && e.userId === file.userId
    );
    if (index !== -1) {
      // 进行替换
      _oldInfo.splice(index, 1, file);
      _fileArray = _oldInfo;
    } else {
      _fileArray = [file, ..._oldInfo];
    }
  } else {
    _fileArray = [file];
  }
  localStorage.setItem("webOnlineEditDocInfo", JSON.stringify(_fileArray));
  return true;
};

// 2. 浏览器打开存储相关数据（重复替换）加密版带过期时间（当前使用）
export const beforeloadNotCheckBycode = (file) => {
  // 设置过期时间(7天)
  const overdueTimeDay = 7;
  file.overdueTime = new Date().getTime() + overdueTimeDay * 24 * 3600 * 1000;
  // 获取缓存数据
  const _oldInfo = fetchLocalStorageData();
  let _fileArray;
  if (_oldInfo.length) {
    const index = _oldInfo.findIndex(
      (e) => e.docId === file.docId && e.userId === file.userId
    );
    if (index !== -1) {
      // 进行替换
      _oldInfo.splice(index, 1, file);
      _fileArray = _oldInfo;
    } else {
      _fileArray = [file, ..._oldInfo];
    }
  } else {
    _fileArray = [file];
  }
  localStorage.setItem(
    "webOnlineEditDocInfo",
    $crypto.encode(JSON.stringify(_fileArray))
  );
  return true;
};

// 3. 浏览器打开存储相关数据（判断重复，无替换）
export const beforeload = (file) => {
  const _oldInfo = fetchLocalStorageData();
  let _fileArray;
  if (_oldInfo) {
    if (
      _oldInfo.some((e) => e.docId === file.docId && e.userId === file.userId)
    ) {
      Message.error("当前文件已打开！");
      return false;
    }
    _fileArray = [file, ..._oldInfo];
  } else {
    _fileArray = [file];
  }
  localStorage.setItem("webOnlineEditDocInfo", JSON.stringify(_fileArray));
  return true;
};

// 清除所有的过期数据（与当前文件无关）（当前使用）
export const beforeunloadByOverdueTime = () => {
  let _itemName = localStorage.getItem("webOnlineEditDocInfo");
  // 获取缓存数据
  const _oldInfo = fetchLocalStorageData();
  if (_oldInfo.length) {
    const nowTime = new Date().getTime();
    // 需要保留的数组
    const saveArray = [];
    _oldInfo.forEach((e) => {
      if (nowTime < e.overdueTime) {
        saveArray.push(e);
      }
    });
    if (_oldInfo.length !== saveArray.length) {
      localStorage.setItem(
        "webOnlineEditDocInfo",
        $crypto.encode(JSON.stringify(saveArray))
      );
    }
  }
};

// 设置浏览器标题
export const setTitle = (title = null) => {
  document.title = `${(title !== -1 && title) || "智慧云多人在线编辑"
    }-在线编辑`;
};

// 检测浏览器内核--返回的是两个key，name：浏览器内核的名称---version：浏览器的版本号
export const isBroswer = () => {
  const _broswer = {};
  const sUserAgent = navigator.userAgent;
  const isChrome = sUserAgent.indexOf("Chrome") > -1;
  if (isChrome) {
    const reChorme = new RegExp("Chrome/(\\d+\\.\\d+(?:\\.\\d+\\.\\d+))?");
    reChorme.test(sUserAgent);
    _broswer.version = parseFloat(RegExp["$1"]);
    _broswer.name = "chrome";
    return _broswer;
  }
  //排除Chrome信息，因为在Chrome的user-agent字符串中会出现Konqueror/Safari的关键字
  const isKHTML =
    (sUserAgent.indexOf("KHTML") > -1 ||
      sUserAgent.indexOf("Konqueror") > -1 ||
      sUserAgent.indexOf("AppleWebKit") > -1) &&
    !isChrome;
  // 排除Chrome 及 Konqueror/Safari 的伪装
  const isMoz = sUserAgent.indexOf("Gecko") > -1 && !isChrome && !isKHTML;
  if (isMoz) {
    const reMoz = new RegExp("rv:(\\d+\\.\\d+(?:\\.\\d+)?)");
    reMoz.test(sUserAgent);
    _broswer.version = parseFloat(RegExp["$1"]);
    _broswer.name = "mozilla";
    return _broswer;
  }
  return _broswer;
};

// 校验 window.name
export const checkWindowName = () => {
  const userId = store.state.routeInfo.userId;
  const docId = store.state.routeInfo.docId;
  const windowName = window.name;
  if (!docId || !userId) return false;
  if (!windowName) return false;
  const storageData = fetchLocalStorageData(userId, docId);
  if (
    storageData.length &&
    parseInt(windowName) === storageData[0].windowName
  ) {
    return true;
  } else {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/window.js